import {isSafeRelativeUrl} from '@lib/url';
import {signIn} from 'next-auth/react';
import useSWRMutation from 'swr/mutation';

type Auth0SignInParams = {
  organization?: string;
  organization_name?: string;
  invitation?: string;
  login_hint?: string;
  callbackUrl?: string;
};

const fetcher = (_key: string, {arg = {params: {}}}: {arg?: {params?: Auth0SignInParams}}) => {
  const params = Object.assign({}, arg?.params ?? {}) as Auth0SignInParams;

  if (params.login_hint) {
    params.login_hint = decodeURIComponent(params.login_hint);
  }

  // We avoid passing the provider as Auth0 is our only one, and it might be creating issue
  // https://github.com/nextauthjs/next-auth/issues/752#issuecomment-705040427
  const {callbackUrl, ...authParams} = params;
  return signIn(`auth0`, {callbackUrl: isSafeRelativeUrl(callbackUrl) ? callbackUrl : `/`}, authParams);
};

/** An async wrapper for next-auth signin, so SWR will handle the async state machine for us */
export const useSignIn = () => {
  const {data, error, trigger, isMutating, reset} = useSWRMutation(`/signin/auth0`, fetcher, {revalidate: false});
  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
